export const DEFAULT_API_ERROR_MESSAGE = 'Something went wrong';
const MAX_ERROR_MESSAGE_LENGTH = 300;

const isServerError = (status) => {
  return status >= 500 && status < 600;
};

const normalizeMessage = (message) => {
  if (typeof message !== 'string') return null;

  const trimmedMessage = message.trim();
  if (trimmedMessage.length > MAX_ERROR_MESSAGE_LENGTH) return null;

  return trimmedMessage;
};

const getMessageFromJson = (data) => {
  if (!data || typeof data !== 'object') return null;

  const candidates = [data.message, data.error?.message, data.error, data.detail, data.title];
  for (const candidate of candidates) {
    const message = normalizeMessage(candidate);
    if (message) return message;
  }

  return null;
};

export const getApiErrorMessage = async (response) => {
  if (!response) return DEFAULT_API_ERROR_MESSAGE;
  if (isServerError(response.status)) return DEFAULT_API_ERROR_MESSAGE;

  let responseText = '';

  try {
    responseText = await response.text();
  } catch (err) {
    return DEFAULT_API_ERROR_MESSAGE;
  }

  const textMessage = normalizeMessage(responseText);
  if (!textMessage) return DEFAULT_API_ERROR_MESSAGE;

  try {
    const jsonMessage = getMessageFromJson(JSON.parse(textMessage));
    return jsonMessage || DEFAULT_API_ERROR_MESSAGE;
  } catch (err) {
    return textMessage;
  }
};

export const createApiError = async (response) => {
  const error = new Error(await getApiErrorMessage(response));
  error.status = response?.status;
  return error;
};

export const throwApiError = async (response) => {
  throw await createApiError(response);
};

export const getDisplayErrorMessage = (error) => {
  if (error?.status >= 500 && error?.status < 600) {
    return DEFAULT_API_ERROR_MESSAGE;
  }
  return normalizeMessage(error?.message) || DEFAULT_API_ERROR_MESSAGE;
};

export const createServerError = (status, message) => {
  const error = new Error(message || DEFAULT_API_ERROR_MESSAGE);
  error.status = status;
  return error;
};